import Button from '@components/v2/ui/Button/Button';
import Icon from '@components/v2/ui/Icon/Icon';
import Typography from '@components/v2/ui/Typography/Typography';
import { SxProps, Theme } from '@mui/material';
import { LucideIcon } from 'lucide-react';
import { useTranslation } from '../../../../../modules/translation/TranslationContext';
import { ExpandCollapseActionConfig } from '../expandCollapseButtonGroup.types';

interface ExpandCollapseActionProps extends ExpandCollapseActionConfig {
  icon: LucideIcon;
  fullWidth: boolean;
  sx: SxProps<Theme>;
}

const ExpandCollapseAction = ({
  label,
  testId,
  icon,
  fullWidth,
  sx,
  onClick,
}: ExpandCollapseActionProps) => {
  const { translate } = useTranslation();

  return (
    <Button
      variant="contained"
      color="secondary"
      size="small"
      shape="square"
      fullWidth={fullWidth}
      testId={testId}
      endIcon={<Icon icon={icon} size="xs" />}
      sx={sx}
      onClick={onClick}
    >
      <Typography variant="micro1" noWrap>
        {translate(label)}
      </Typography>
    </Button>
  );
};

export default ExpandCollapseAction;
